import $http from '../../axios';
import {Message, MessageBox, Notification} from 'element-ui';

export async function fetchDocuments({commit}, id) {

    let params = {
        warehouse_id: id
    };

    commit('setPreloader', true);

    await $http.get('/api/documentos-por-sucursal-cliente', {params})
        .then((response) => {
            commit('setDocuments', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener las solicitudes',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function fetchStates({commit}) {
    await $http
        .get('/api/parametros-por-codigo/GS01')
        .then(response => {
            commit('setStates', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchRequestTypes({commit}) {
    await $http
        .get('/api/parametros-por-codigo/RTGM')
        .then(response => {
            commit('setRequestTypes', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchDevolutionReasons({commit}) {
    await $http
        .get('/api/parametros-por-codigo/136')
        .then(response => {
            commit('setDevolutionReasons', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchGuaranteeReasons({commit}) {
    await $http
        .get('/api/parametros-por-codigo/DRGM')
        .then(response => {
            commit('setGuaranteeReasons', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchApprovalStates({commit}) {
    await $http
        .get('/api/parametros-por-codigo/GAS01')
        .then(response => {
            commit('setApprovalStates', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchApprovalReasons({commit}) {
    await $http
        .get('/api/parametros-por-codigo/GAR01')
        .then(response => {
            commit('setApprovalReasons', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchOptions({commit}) {
    await $http
        .get('/api/parametros-por-codigo/PGOP')
        .then(response => {
            commit('setOptions', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchModel({commit}) {
    await $http
        .get('/api/modelo-por-codigo/055')
        .then(response => {
            commit('setModel', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function findAll({commit, state, dispatch}) {
    commit('setPreloader', true);

    await $http.get('/api/solicitud-de-garantia', {params: state.filters})
        .then((response) => {
            commit('setRequestsGuarantees', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            console.error(error);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener las solicitudes',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export function generateReportCsv({ commit, state }) {
    commit('setPreloader', true);

    $http.get('/api/solicitud-de-garantia-csv', {
        params: state.filters,
        responseType: 'blob'
    })
    .then((response) => {
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reporte-garantias.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        commit('setPreloader', false);
    })
    .catch((error) => {
        commit('setPreloader', false);
        console.error(error);

        Notification.error({
            title: 'Error',
            message: 'Error al generar el reporte CSV',
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    });
}


export async function getTypesStates({commit, dispatch}) {
    await dispatch('getParametersByCodeTable', 'GS01')
        .then(data => commit('setStates', data))
        .catch(e => console.error(e));
}

export async function getTypesStatesEvaluation({commit, dispatch}) {
    await dispatch('getParametersByCodeTable', 'GAS01')
        .then(data => commit('setStatesEvaluation', data))
        .catch(e => console.error(e));
}

export async function getApprovalReasons({commit, dispatch}) {
    await dispatch('getParametersByCodeTable', 'GAR01')
        .then(data => commit('setApprovalReasons', data))
        .catch(e => console.error(e));
}

export async function getParametersByCodeTable({commit, state, dispatch}, code) {
    return new Promise(async (resolve, reject) => {

        await $http.get('/api/parametros-por-codigo/' + code)
            .then((response) => {
                resolve(response.data.data);
            }).catch((error) => {
                Notification.error({
                    title: 'Error',
                    message: 'Error al obtener los parametros',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                reject();
            });
    });
}


export async function getProductsRequest({commit, state, dispatch}, filter) {

    return new Promise(async (resolve, reject) => {

        if (filter.length >= 3) {
            let params = {
                params: {
                    filter: filter
                }
            };

            await $http.get('/api/buscar-productos', params)
                .then((response) => {
                    resolve(response.data.data);
                }).catch((error) => {
                    Notification.error({
                        title: 'Error',
                        message: 'Error al obtener los productos',
                        type: 'error',
                        duration: 3000,
                        customClass: 'notification-box',
                    });
                    reject();
                });
        } else {
            resolve([]);
        }
    });
}

export async function getProducts({commit, state, dispatch}, filter) {
    await dispatch('getProductsRequest', filter)
        .then(data => commit('setProducts', data))
        .catch(e => console.error(e));
}

export async function getProductsToSend({commit, state, dispatch}, filter) {
    await dispatch('getProductsRequest', filter)
        .then(data => commit('setProductsToSend', data))
        .catch(e => console.error(e));
}

export async function getProductsToSendTwo({commit, state, dispatch}, filter) {
    await dispatch('getProductsRequest', filter)
        .then(data => commit('setProductsToSendTwo', data))
        .catch(e => console.error(e));
}

export async function getProductsToSendThree({commit, state, dispatch}, filter) {
    await dispatch('getProductsRequest', filter)
        .then(data => commit('setProductsToSendThree', data))
        .catch(e => console.error(e));
}

export async function create({commit, state, dispatch}, files) {

    return new Promise(async (resolve, reject) => {

        commit('setSending', true);
        commit('setPreloader', true);

        let form_data = new FormData();

        const user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

        commit('setContactWarehouseIdRequestGuarantee', user_b2b.id);

        for (const property in state.request_guarantee) {
            if (!property.includes('images')) {
                form_data.append(property, state.request_guarantee[property]);
            }
        }

        let keys = [
            'images_product',
            'other_images',
            'images_guide'
        ];

        keys.map(key => {
            for (let i = 0; i < files[key].length; i++) {
                form_data.append(key + '_loaded[' + i + ']', files[key][i]);
            }
        });

        await $http.post('/api/solicitud-de-garantia', form_data)
            .then(async (response) => {
                await dispatch('findAll');
                commit('setModalShow', false);
                commit('resetRequestGuarantee');
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.success({
                    title: 'Éxito!',
                    message: 'Solicitud creada exitosamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });
            }).catch((error) => {
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.error({
                    title: 'Error',
                    message: 'Error al crear la solicitud',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
            });
    });
}

export async function update({commit, state, dispatch}) {
    commit('setSending', true);
    commit('setPreloader', true);

    let request_guarantee = JSON.parse(JSON.stringify(state.request_guarantee));

    request_guarantee.documents_products = JSON.stringify(state.request_guarantee.return.documents_products);

    await $http.post('/api/solicitud-de-garantia/' + state.request_guarantee.id, request_guarantee)
        .then(async (response) => {
            await dispatch('findAll');
            commit('setModalShow', false);
            commit('resetRequestGuarantee');
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.success({
                title: 'Éxito!',
                message: 'Solicitud actualizada exitosamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al actualizar la solicitud',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function updateWithNewState({commit, state, dispatch}, files) {
    commit('setSending', true);
    commit('setPreloader', true);

    let keys = [
        'images_product',
        'other_images',
        'images_guide'
    ];

    let form_data = new FormData();

    for (const property in state.request_guarantee) {
        if (property !== 'attachments_deleted' && !['images_product_loaded', 'other_images_loaded', 'images_guide_loaded'].includes(property)) {
            form_data.append(property, state.request_guarantee[property]);
        }
    }

    keys.map(key => {
        if (files[key]) {
            for (let i = 0; i < files[key].length; i++) {
                form_data.append(key + '_loaded[' + i + ']', files[key][i]);
            }
        }
    });

    for (let i = 0; i < state.request_guarantee.attachments_deleted.length; i++) {
        form_data.append('attachments_deleted[' + i + ']', state.request_guarantee.attachments_deleted[i].id);
    }

    form_data.append('documents_products', JSON.stringify(state.request_guarantee.return.documents_products));

    await $http.post('/api/solicitud-de-garantia/nuevo-estado/' + state.request_guarantee.id, form_data)
        .then(async (response) => {
            await dispatch('findAll');
            commit('setModalShow', false);
            commit('resetRequestGuarantee');
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.success({
                title: 'Éxito!',
                message: 'Solicitud actualizada exitosamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al actualizar la solicitud',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function findForId({commit, state, dispatch}, id) {

    commit('setPreloader', true);

    await $http.get('/api/solicitud-de-garantia/' + id)
        .then((response) => {

            let request_guarantee = response.data.data;

            request_guarantee.return.documents_products.map(dp => {

                if (dp.requested_quantity === null) {
                    let _dpi = request_guarantee.invoice.documents_products.find(dpi => dpi.product_id === dp.product_id);

                    if (_dpi) {
                        dp.requested_quantity = _dpi.quantity;
                    }
                }

                if (dp.received_quantity === null) {
                    dp.received_quantity = dp.requested_quantity;
                }

                if (dp.authorized_quantity === null) {
                    dp.authorized_quantity = dp.received_quantity;
                }

            });

            commit('setRequestGuarantee', request_guarantee);

            let step = 1;
            let action = 'Editar';

            let states = JSON.parse(JSON.stringify(state.request_guarantee.request_guarantee_states));

            let last_state = null;

            states.map(s => {
                if (s.state.code_parameter !== 'PGS9'){
                    last_state = s;
                }
            })

            if (last_state && last_state.state) {

                let step_code = last_state.state.code_parameter;

                let step_obj = state.steps.find(s => s.code === step_code);

                if (step_obj) {
                    step = step_obj.step;
                }

                let type = state.request_types.find(t => t.id === state.request_guarantee.type_id);

                if (step_code !== 'PGS5' || (type && type.code_parameter === 'RTGM02')) {
                    step++;
                }

                if (step_code === 'PGS3' && type && type.code_parameter === 'RTGM01') {
                    step++;
                } else if (step_code === 'PGS4' && type && type.code_parameter === 'RTGM02') {
                    step++;
                } else if (step_code === 'PGS6' && type && type.code_parameter === 'RTGM01') {
                    step = 3;
                }

                if (state.request_guarantee.approval_status && state.request_guarantee.approval_status.code_parameter === 'PGAS3' && step === 5){
                    step = 3;
                }
            }

            commit('setStep', step);
            commit('setAction', action);
            commit('setStepAvailable', step);
            commit('setPreloader', false);

        }).catch((error) => {

            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al obtener la solicitud',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function deleteAttachment({commit, state}, attachment) {
    await MessageBox.confirm('¿Está seguro de eliminar el adjunto?', 'Eliminar adjunto', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        customClass: 'notification-danger'
    }).then(async (result) => {
        commit('addAttachmentDeleteRequestGuarantee', attachment);
        commit('deleteAttachmentRequestGuarantee', attachment);
    }).catch((e) => {
        console.error(e);
    });
}

export async function destroy({commit, state, dispatch}, request_guarantee) {

    await MessageBox.confirm('¿Está seguro de rechazar la solicitud?', 'Rechazar', {
        confirmButtonText: 'Rechazar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        inputPlaceholder: 'Observaciones',
        customClass: 'notification-danger',
    }).then(async (result) => {

        if (result) {
            commit('setPreloader', true);

            await $http.post('/api/solicitud-de-garantia/anular/' + request_guarantee.id, request_guarantee)
                .then(async (response) => {
                    await dispatch('findAll');
                    commit('setPreloader', false);

                    commit('setModalShow', false);
                    commit('resetRequestGuarantee');

                    Notification.success({
                        title: 'Éxito!',
                        message: 'Solicitud rechazada exitosamente',
                        type: 'success',
                        duration: 3000,
                        customClass: 'notification-box',
                    });

                    Notification.success({
                        title: 'Éxito!',
                        message: 'Solicitud rechazada exitosamente',
                        type: 'success',
                        duration: 3000,
                        customClass: 'notification-box',
                    });
                }).catch((error) => {
                    commit('setPreloader', false);

                    Notification.error({
                        title: 'Error',
                        message: 'Error al rechazar la solicitud',
                        type: 'error',
                        duration: 3000,
                        customClass: 'notification-box',
                    });
                });
        }
    }).catch((e) => {
        console.error(e);
    });
}

export async function downloadAttachment({commit}, attachment) {

    commit('setPreloader', true);

    await $http({
        url: '/api/solicitud-de-garantia/descargar-adjunto/' + attachment.id,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {

        commit('setPreloader', false);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', attachment.original_name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    });
}

export async function getSellers({commit, state}) {
    let leadership_id = state.filters.leadership_id;

    commit('setPreloader', true);

    if (leadership_id === null) {
        await $http.get('/api/sellers').then((response) => {
            commit('setSellers', response.data.data);
            commit('setPreloader', false);
        }).catch(() => commit('setPreloader', false));

    } else {

        await $http.get('/api/sellers/' + leadership_id).then((response) => {
            commit('setSellers', response.data.data);
            commit('setPreloader', false);
        }).catch(() => commit('setPreloader', false));
    }
}

export async function finalizeRequestGuarantee({commit, state, dispatch}) {
    commit('setSending', true);
    commit('setPreloader', true);

    return new Promise(async (resolve, reject) => {
        await $http.post('/api/solicitud-de-garantia/finalizar/' + state.request_guarantee.id, state.request_guarantee)
            .then(async (response) => {
                await dispatch('findAll');
                commit('setModalShow', false);
                commit('resetRequestGuarantee');
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.success({
                    title: 'Éxito!',
                    message: 'Solicitud finalizada exitosamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });

                if (response.data.data.data.data){
                    commit('setShowToModalPdf', response.data.data.data.data);
                    resolve(response.data.data.data.data);
                }else {
                    commit('setShowToModalPdf', response.data.data.data);
                    resolve(response.data.data.data);
                }

            }).catch((error) => {
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.error({
                    title: 'Error',
                    message: error.response.data.message,
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                    dangerouslyUseHTMLString: true,
                });
                reject();
            });
    });
}

export async function fetchDocumentsByThread({commit, state}) {
    await $http
        .get('/api/back-order/' + state.request_guarantee.invoice_id)
        .then(response => {
            commit('setDocumentsByThread', response.data.data);
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: '¡Error!',
                message: 'Error al actualizar los valores del documento.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchModels({commit}) {
    commit('setPreloader', true);

    let params = {
        codes: ['155', '186']
    };

    await $http.get('/api/modelos-devoluciones', {params})
        .then((response) => {
            commit('setModels', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener los modelos',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function validateInventory({commit, state}) {
    commit('setPreloader', true);

    await $http.get('/api/validar-inventario-documento/' + state.request_guarantee.return_id + '/' + 0)
        .then((response) => {

            let request_guarantee = JSON.parse(JSON.stringify(state.request_guarantee));

            request_guarantee.return.documents_products.map(dp => {
                let ssdp = response.data.data.find(sdp => sdp.id === dp.id);

                if (ssdp) {
                    dp.stock = ssdp.stock;
                }
            });

           commit('setRequestGuarantee', request_guarantee)

            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener los modelos',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/guarantees_admin/actions.js